<script setup lang="ts">
    defineProps<{
        title: string,
        text: string
    }>();
</script>

<template>
    <div
        class="venue-host-message"
    >
        <div
            v-if="title"
            class="venue-host-message__title"
        >
            {{ title }}
        </div>
        <div
            v-if="text"
            class="venue-host-message__text"
        >
            {{ text }}
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .venue-host-message {
        z-index: var(--zindex-popover);
        display: inline-flex;
        flex-direction: column;
        padding: var(--spacing-03);
        border: solid 1px var(--border-primary);
        background-color: var(--color-pure-white);
        border-end-start-radius: var(--size-1);
        border-start-end-radius: var(--size-1);
        border-start-start-radius: var(--size-1);
        pointer-events: none;

        &__title {
            font-size: var(--font-regular);
            font-weight: var(--font-weight-medium);
            line-height: var(--line-height-150);
        }

        &__text {
            font-size: var(--font-regular);
            line-height: var(--line-height-150);
        }
    }
</style>
